<custom-view *ngIf="isCustomView" [component]="customComponent" [customDataBinding]="customData">
</custom-view>

<standard-task *ngIf="!isCustomView" [aggregate]="aggregate">
</standard-task>